/**
 * Utilidades de pines compartidas entre HardwareConfigurator, FirmwareGenerator,
 * ScadaEditor y WslScriptEditor.
 */

/** Pines por defecto de cada IC de expansión */
export const IC_DEFAULT_PINS = {
  ic595:    { data: 23, clock: 18, latch: 5  },
  ic165:    { data: 19, clock: 18, load:  17 }, // clock compartido con 595
  ads1115:  { sda: 21,  scl: 22 },
  mcp23017: { sda: 21,  scl: 22 },              // I2C compartido con ADS
};

/**
 * Devuelve un mapa { gpio → "etiqueta del propietario" } con TODOS los pines
 * ocupados (I/O nativa + ICs de expansión).
 *
 * @param {object} hw  Hardware config completo (hw.native + hw.expansion)
 * @returns {Record<number, string>}
 */
export function getUsedPinsMap(hw) {
  const map = {};
  if (!hw) return map;

  // I/O nativa
  hw.native?.digital_in?.forEach(p  => { if (p.gpio) map[p.gpio] = "DIN"; });
  hw.native?.digital_out?.forEach(p => { if (p.gpio) map[p.gpio] = "DOUT"; });
  hw.native?.analog_in?.forEach(p   => { if (p.gpio) map[p.gpio] = "AIN"; });
  hw.native?.pwm_out?.forEach(p     => { if (p.gpio) map[p.gpio] = "PWM"; });

  const exp = hw.expansion;
  if (!exp) return map;

  if (exp.ic595?.enabled && exp.ic595.count > 0) {
    const p = exp.ic595.pins;
    if (p.data)  map[p.data]  = "595·DATA";
    if (p.clock) map[p.clock] = "595/165·CLK";
    if (p.latch) map[p.latch] = "595·LATCH";
  }
  if (exp.ic165?.enabled && exp.ic165.count > 0) {
    const p = exp.ic165.pins;
    if (p.data)  map[p.data]  = "165·DATA";
    if (p.clock) map[p.clock] = "595/165·CLK"; // puede ya estar por 595
    if (p.load)  map[p.load]  = "165·LOAD";
  }
  if (exp.ads1115?.enabled && exp.ads1115.count > 0) {
    const p = exp.ads1115.pins;
    if (p.sda) map[p.sda] = "I2C·SDA";
    if (p.scl) map[p.scl] = "I2C·SCL";
  }
  if (exp.mcp23017?.enabled && exp.mcp23017.count > 0) {
    const p = exp.mcp23017.pins;
    if (p.sda) map[p.sda] = "I2C·SDA";
    if (p.scl) map[p.scl] = "I2C·SCL";
  }

  return map;
}

/**
 * Devuelve true si un GPIO está libre para usarse.
 * @param {number} gpio
 * @param {object} hw
 * @param {string[]} [allowOwners]  Propietarios que se consideran compatibles (ej: compartir I2C)
 */
export function isPinFree(gpio, hw, allowOwners = []) {
  const map = getUsedPinsMap(hw);
  const owner = map[gpio];
  if (!owner) return true;
  return allowOwners.includes(owner);
}
